import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,_vm._b({attrs:{"filled":"","label":"EFP #","rules":_vm.rules,"type":"number","error-messages":_vm.farmNumErrorMessages,"disabled":_vm.loading},on:{"input":_vm.onInput},model:{value:(_vm.farm_number),callback:function ($$v) {_vm.farm_number=$$v},expression:"farm_number"}},'v-text-field',_vm.commonProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }